export enum CPTCodeDrawerActions {
  Save = "save",
  SignAndLock = "signAndLock",
}

export type CPTCodeDrawerAction = "save" | "signAndLock";

export enum CPTCodeQuestionsLinkIds {
  Code = "cptCode",
  Notes = "cptCodeNotes",
  DiagnosesFormset = "cptDiagnosesFormset",
  DiagnosesFormsetCode = "cptDiagnosesFormsetCode",
  DiagnosesFormsetDiagnosis = "cptDiagnosesFormsetDiagnosis",
  DiagnosesFormsetAddToProblemList = "cptDiagnosesFormsetAddToProblemList",
  ModifiersFormset = "cptModifiersFormset",
  ModifiersFormsetCode = "cptModifiersFormsetCode",
  ModifiersFormsetModifier = "cptModifiersFormsetModifier",
  Units = "cptUnits",
}

export enum CPTCodeActionLabels {
  Deleted = "Deleted by",
  Updated = "Last Updated by",
}
